const options = [
  {
    value: 1,
    label: "时间"
  },
  {
    value: 2,
    label: "门店"
  },
  {
    value: 3,
    label: "顾客"
  },
  {
    value: 4,
    label: "会员"
  },
  {
    value: 5,
    label: "客流渠道"
  },
  {
    value: 6,
    label: "预约渠道"
  },
  {
    value: 7,
    label: "项目"
  },
  {
    value: 8,
    label: "储值卡"
  },
  {
    value: 9,
    label: "理疗师"
  },
  {
    value: 10,
    label: "活动"
  },
  {
    value: 11,
    label: "优惠券"
  },
  {
    value: 12,
    label: "券"
  },
  {
    value: 13,
    label: "活动"
  }
];
const marketHeader = [
  // 会员指标概况
  {
    name: "cust_index",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true, //会员资源搜索
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  // 会员趋势
  {
    name: "cust_target_trend",
    contrast: true,
    quckTime: "MonthTabSix",
    datePicker: "MonthPicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false
    ],
    options: options
  },
  // 会员增长
  {
    name: "cust_target",
    contrast: false,
    quckTime: "MonthTab",
    datePicker: "MonthPicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false
    ],
    options: options
  },
  // 留存分析
  {
    name: "cust_save",
    contrast: false,
    quckTime: "MonthTabFive",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 忠诚度
  {
    name: "cust_faith",
    contrast: true,
    quckTime: "MonthTabFour",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 新会员来源分析
  {
    name: "cust_newMembers",
    contrast: true,
    quckTime: "MonthTabTen",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 会员分析
  {
    name: "cust_Members",
    contrast: true,
    // quckTime: 'MonthTabNine',
    quckTime: "",
    // datePicker: 'DatePicker',
    datePicker: "",
    headerShow: [
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 活动概况
  {
    name: "activity_index",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  // 活动趋势
  {
    name: "activity_target_trend",
    contrast: true,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 活动详情
  {
    name: "activity_detail",
    contrast: false,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 漏斗转化
  {
    name: "activity_change",
    contrast: false,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 留存分析
  {
    name: "activity_save",
    contrast: false,
    quckTime: "MonthTabEight",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 优惠券概况
  {
    name: "coupons_index",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  // 优惠券趋势
  {
    name: "coupons_target_trend",
    contrast: true,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 优惠券详情
  {
    name: "coupons_detail",
    contrast: false,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 漏斗转化
  {
    name: "coupons_change",
    contrast: false,
    quckTime: "MonthTabSeven",
    datePicker: "DatePicker",
    headerShow: [
      true,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 留存分析
  {
    name: "coupons_save",
    contrast: false,
    quckTime: "MonthTabEight",
    datePicker: "DatePicker",
    headerShow: [
      true,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 积分兑换概况
  // {
  //   name: "integral_index",
  //   contrast: false,
  //   quckTime: "",
  //   datePicker: "",
  //   time: "Month",
  //   headerShow: [
  //     true,
  //     false,
  //     true,
  //     true,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     true,
  //     false,
  //     false,
  //     false,
  //     false
  //   ],
  //   // 时间，门店，顾客，会员
  //   options: options
  // },
  // 积分趋势
  {
    name: "integral_target_trend",
    contrast: true,
    quckTime: 'MonthTabTen',
    datePicker: 'DatePicker',
    headerShow: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // // 兑换商品分析
  // {
  //   name: "integral_goods",
  //   contrast: false,
  //   quckTime: "MonthTabFour",
  //   datePicker: "DatePicker",
  //   headerShow: [
  //     true,
  //     false,
  //     false,
  //     true,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     false,
  //     true
  //   ],
  //   options: options
  // }
  // 会员等级趋势
  {
    name: "member_level_trend",
    contrast: true,
    quckTime: 'MonthTabSix',
    datePicker: 'MonthPicker',
    headerShow: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    options: options
  },
  // 会员等级增长
  {
    name: "member_level_growth",
    contrast: false,
    quckTime: 'MonthTabSix',
    datePicker: 'MonthPicker',
    time: '',
    headerShow: [
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
    ],
    options: options,
    twoRow: true,
  },
];
const marketContent = [
  // 会员概况
  {
    name: "cust_index",
    value: [
      {
        name: "cust_index",
        selectChart: "",
        selectTable: "SelectDrop",
        normalTable: "ColorTable",
        oneChart: "",
        chartKey: "",
        tableTitle: "门店",
        tableKey: "market_member_general2",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        focus: 2,
        headerType: 4,
        parentID: -1,
        TableconstantType: 8,
        dateFormat: 1,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        identityType: 2,
        sortIndex: 1
      }
    ]
  },
  // 会员趋势
  {
    name: "cust_target_trend",
    value: [
      {
        name: "cust_target_trend",
        xname: "cust_target_trend",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        compareTable: "OneLevel",
        oneChart: "VueHighchart",
        chartKey: "market_member_cust_indicator_trend2",
        tableKey: "market_member_cust_indicator_trend2",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "2",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: true,
        isChart: true,
        isTable: true,
        tableTitle: "日期",
        headerType: 1,
        TableconstantType: 1,
        ChartconstantType: 1,
        constantKey: "",
        parentID: 0,
        dateFormat: 2,
        ascending: 0,
        sortIndex: 1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        identityType: 2,
        byWhichWay: "byMonth"
      }
    ]
  },
  // 会员增长
  {
    name: "cust_target",
    value: [
      {
        name: "cust_target",
        xname: "RatioOne",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "ContrantOneTable",
        oneChart: "VueColumn",
        chartKey: "market_member_cust_mom2",
        tableKey: "market_member_cust_mom2",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "日期",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        headerType: 1,
        constantKey: "",
        parentID: 0,
        TableconstantType: 1,
        ChartconstantType: 3,
        IndexCompareType: 1,
        type: 2,
        dateFormat: 2,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        sortIndex: 1,
        identityType: 2
      },
      {
        xname: "RatioTwo",
        chartKey: "market_member_cust_yoy2",
        tableKey: "market_member_cust_yoy2",
        type: 1
      }
    ]
  },
  // 留存分析
  {
    name: "cust_save",
    value: [
      {
        name: "cust_save",
        xname: "keep",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "RetainTable",
        oneChart: "",
        chartKey: "retained_analysis_member_retain2",
        tableKey: "retained_analysis_member_retain2",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "",
        tableTitle: "日期",
        isDay: false,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: false,
        isTableKey: true,
        constantKey: "ladder_diagram_dimension",
        // constantKeyAxis: 'dimensionality_weekDayCustFlow',
        isIndex: true,
        chartTitle: "会员数",
        identityType: 2
      },
      {
        xname: "consume",
        chartKey: "retained_analysis_member_retain_consume2",
        tableKey: "retained_analysis_member_retain_consume2",
        chartTitle: "会员数"
      }
    ]
  },
  // 忠诚度
  {
    name: "cust_faith",
    value: [
      {
        name: "cust_faith",
        xname: "cycle",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        compareTable: "OneLevel",
        oneChart: "VueColumn",
        tableTitle: "复购周期",
        chartAddress: "center",
        tableAddress: "bottom",
        tableNum: "6",
        chartNum: "1",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        chartKey: "loyalty_member_purchase_cycle_drawing2",
        tableKey: "loyalty_member_purchase_cycle_table_key2",
        constantKey: "loyalty_member_purchase_cycle_dimension",
        headerType: 1,
        parentID: -1,
        TableconstantType: 2,
        ChartconstantType: 2,
        isIndex: true,
        ascending: 0,
        identityType: 3,
        sortIndex: 1
      },
      {
        xname: "frequency",
        chartKey: "loyalty_member_consume_frequency_drawing2",
        tableKey: "loyalty_member_consume_frequency_table_key2",
        constantKey: "loyalty_member_consume_frequency_dimension",
        tableTitle: "消费频次"
      }
    ]
  },
  // 新会员来源分析
  {
    name: "cust_newMembers",
    value: [
      {
        name: "cust_newMembers",
        xname: "Trend",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "cust_source_ana_member_source_trend2",
        tableKey: "cust_source_ana_member_source_trend2",
        constantKey: "cust_source_member_dimension",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "来源渠道",
        tableNum: "6",
        chartNum: "1",
        isTwo: false,
        isDay: true,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        headerType: 2,
        parentID: -1,
        TableconstantType: 2,
        ChartconstantType: 4,
        dateFormat: 1,
        isIndex: true,
        sortIndex: 1,
        identityType: 2,
        chartSort: false
      },
      {
        xname: "Distribute",
        chartKey: "cust_source_ana_member_source_worth2",
        tableKey: "cust_source_ana_member_source_worth2",
        isTime: false,
        constantKey: "cust_source_member_dimension",
        oneChart: "VueColumn",
        ChartconstantType: 2,
        chartSort: true
      }
    ]
  },
  // 会员分析
  {
    name: "cust_Members",
    value: [
      {
        name: "cust_Members",
        xname: "Attribute",
        chartKey: "member_attr_member_ana_drawing2",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "TableCard",
        compareTable: "OneLevel",
        oneChart: "VueColumn",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "顾客类型",
        tableNum: "6",
        chartNum: "1",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        headerType: 1,
        parentID: -1,
        TableconstantType: 2,
        ChartconstantType: 2,
        dateFormat: 1,
        isIndex: true,
        ascending: 0,
        sortIndex: 1,
        identityType: 2,
        keyList: [
          {
            constantKey: "gender_attr_member_ana_dimension"
          },
          {
            constantKey: "age_attr_member_ana_dimension"
          },
          {
            constantKey: "address_attr_member_ana_dimension"
          },
          {
            constantKey: "marriage_attr_member_ana_dimension"
          },
          {
            constantKey: "country_attr_member_ana_dimension"
          },
          {
            constantKey: "feature_attr_member_ana_dimension"
          },
          {
            constantKey: "children_attr_member_ana_dimension"
          }
        ]
      },
      {
        xname: "customer",
        chartKey: "custType_attr_member_ana_drawing2",
        tableKey: "custType_attr_member_ana_table_key2",
        constantKey: "custType_attr_member_ana_dimension",
        tableTitle: "顾客类型"
      },
      {
        xname: "member",
        chartKey: "memberType_attr_member_ana_drawing2",
        tableKey: "memberType_attr_member_ana_table_key2",
        constantKey: "memberType_attr_member_ana_dimension",
        oneChart: "VueColumn",
        tableTitle: "会员类型"
      },
      {
        xname: "Bind",
        chartKey: "mem_bind_attr_member_ana_drawing2",
        tableKey: "mem_bind_attr_member_ana_table_key2",
        constantKey: "mem_bind_attr_member_ana_dimension",
        oneChart: "VueColumn",
        tableTitle: "会员绑定"
      },
      {
        xname: "focusWX",
        chartKey: "wxSubscribe_attr_member_ana_drawing2",
        tableKey: "wxSubscribe_attr_member_ana_table_key2",
        constantKey: "wxSubscribe_attr_member_ana_dimension",
        oneChart: "VueColumn",
        tableTitle: "微信关注"
      },
      {
        xname: "Balance",
        chartKey: "storeBalance_attr_member_ana_drawing2",
        tableKey: "storeBalance_attr_member_ana_table_key2",
        constantKey: "storeBalance_attr_member_ana_dimension",
        oneChart: "VueColumn",
        tableTitle: "储值余额"
      },
      {
        xname: "Money",
        chartKey: "storeAmount_attr_member_ana_drawing2",
        tableKey: "storeAmount_attr_member_ana_table_key2",
        constantKey: "storeAmount_attr_member_ana_dimension",
        oneChart: "VueColumn",
        tableTitle: "储值金额"
      }
    ]
  },
  // 活动概况
  {
    name: "activity_index",
    value: [
      {
        name: "activity_index",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "ColorTable",
        oneChart: "",
        chartKey: "",
        tableTitle: "活动名称",
        tableKey: "promotion_general_table_key",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        headerType: 4,
        focus: 2,
        parentID: -1,
        TableconstantType: 10,
        dateFormat: 1,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        identityType: 2,
        sortIndex: 2,
        discountType: 1
      }
    ]
  },
  // 活动趋势
  {
    name: "activity_target_trend",
    value: [
      {
        name: "activity_target_trend",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        chartKey: "promotion_trend",
        tableKey: "promotion_trend",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "2",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: true,
        isChart: true,
        isTable: true,
        tableTitle: "日期",
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1,
        constantKey: "",
        parentID: 0,
        dateFormat: 1,
        ascending: 0,
        sortIndex: 1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        identityType: 3,
        discountType: 1,
        byWhichWay: "byDay",
        needDiscountID: true
      }
    ]
  },
  // 活动详情
  {
    name: "activity_detail",
    value: [
      {
        name: "activity_detail",
        xname: "store",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueColumn",
        chartKey: "promotion_detail_store_drawing",
        tableKey: "promotion_detail_store_table_key",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "2",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: false,
        isChart: true,
        isTable: true,
        tableTitle: "门店",
        headerType: 2,
        TableconstantType: 8,
        ChartconstantType: 8,
        constantKey: "",
        parentID: -1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        ascending: 0,
        sortIndex: 1,
        identityType: 2,
        discountType: 1,
        needDiscountID: true,
        chartSort: true,
        isFilter: false
      },
      {
        xname: "projects",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        chartKey: "promotion_detail_item_drawing",
        tableKey: "promotion_detail_item_table_key",
        chartNum: "1",
        tableTitle: "项目",
        normalTable: "OneTable",
        headerType: 1,
        sortIndex: 1,
        ChartconstantType: 12,
        TableconstantType: 12,
        chartSort: true,
        isFilter: true
      },
      {
        xname: "members",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        chartKey: "promotion_detail_cust_type_drawing",
        tableKey: "promotion_detail_cust_type_table_key",
        constantKey: "cust_type_promotion_detail_dimension",
        chartNum: "2",
        tableTitle: "会员类型",
        headerType: 1,
        sortIndex: 1,
        normalTable: "OneTable",
        ChartconstantType: 2,
        TableconstantType: 2,
        chartSort: true,
        isFilter: false
      },
      {
        xname: "card",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        chartKey: "promotion_detail_open_card_drawing",
        tableKey: "promotion_detail_open_card_table_key",
        constantKey: "open_card_promotion_detail_dimension",
        chartNum: "1",
        tableTitle: "储值金额",
        headerType: 1,
        sortIndex: 1,
        normalTable: "OneTable",
        ChartconstantType: 2,
        TableconstantType: 2,
        chartSort: false,
        isFilter: false
      },
      {
        xname: "channel",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        chartKey: "promotion_detail_new_cust_source_drawing",
        tableKey: "promotion_detail_new_cust_source_table_key",
        constantKey: "cust_source_promotion_detail_dimension",
        chartNum: "2",
        tableTitle: "来源渠道",
        headerType: 1,
        sortIndex: 1,
        normalTable: "OneTable",
        ChartconstantType: 2,
        TableconstantType: 2,
        chartSort: true,
        isFilter: false
      }
    ]
  },
  // 漏斗转化
  {
    name: "activity_change",
    value: [
      {
        name: "activity_change",
        xname: "cycle",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        compareTable: "",
        oneChart: "Funnel",
        chartKey: "funnel_transfer_secondary_funnel_drawing",
        tableKey: "funnel_transfer_secondary_table_key",
        constantKey: "secondary_transfer_funnel_dimension",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: false,
        isChart: true,
        isTable: true,
        tableTitle: "门店",
        headerType: 1,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 2,
        dateFormat: 1,
        isIndex: true,
        ascending: 0,
        chartZoom: true,
        isTableKey: true,
        sortIndex: 1,
        identityType: 3,
        discountType: 1,
        needDiscountID: true
      },
      {
        xname: "lasttime",
        chartKey: "funnel_transfer_store_value_funnel_drawing",
        tableKey: "funnel_transfer_store_value_table_key",
        constantKey: "open_card_transfer_funnel_dimension"
      }
    ]
  },
  // 留存分析
  {
    name: "activity_save",
    value: [
      {
        name: "activity_save",
        xname: "customer",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "RetainTable",
        oneChart: "",
        chartKey: "retained_analysis_cust_promotion",
        tableKey: "retained_analysis_cust_promotion",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "",
        tableTitle: "日期",
        isDay: false,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: false,
        isTableKey: true,
        constantKey: "ladder_diagram_dimension",
        isIndex: true,
        chartTitle: "使用人数",
        identityType: 3,
        discountType: 1,
        needDiscountID: true
      },
      {
        xname: "expense",
        chartKey: "retained_analysis_cust_consume_promotion",
        tableKey: "retained_analysis_cust_consume_promotion",
        chartTitle: "活动使用人数"
      }
    ]
  },
  // 优惠券概况
  {
    name: "coupons_index",
    value: [
      {
        name: "coupons_index",
        selectChart: "",
        selectTable: "SelectDrop",
        normalTable: "ColorTable",
        oneChart: "",
        chartKey: "",
        tableTitle: "优惠券名称",
        tableKey: "coupon_general_table_key",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        focus: 2,
        headerType: 4,
        parentID: -1,
        TableconstantType: 11,
        dateFormat: 1,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        identityType: 2,
        sortIndex: 2,
        discountType: 2
      }
    ]
  },
  // 优惠券趋势
  {
    name: "coupons_target_trend",
    value: [
      {
        name: "coupons_target_trend",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        chartKey: "coupon_trend",
        tableKey: "coupon_trend",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "2",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: true,
        isChart: true,
        isTable: true,
        tableTitle: "日期",
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1,
        constantKey: "",
        parentID: 0,
        dateFormat: 1,
        ascending: 0,
        sortIndex: 1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        identityType: 3,
        discountType: 2,
        byWhichWay: "byDay",
        needDiscountID: true
      }
    ]
  },
  // 优惠券详情
  {
    name: "coupons_detail",
    value: [
      {
        name: "coupons_detail",
        xname: "status",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        chartKey: "coupon_details_status_pie_drawing",
        tableKey: "coupon_details_status_pie_table_key",
        constantKey: "coupon_status_pie_one_dimension",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        normalTable: "TableAnalysis",
        firstChart: "VuePie",
        secondChart: "VuePie",
        PieconstantType: 2,
        TableconstantType: 2,
        tableTitle: "优惠券详情",
        queryKey: "coupons",
        type: 1,
        compareChart: "VuePie2",
        isTime: false,
        isTwo: true,
        isDay: true,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        headerType: 1,
        parentID: 0,
        sortIndex: 1,
        dateFormat: 1,
        isIndex: true,
        identityType: 2,
        discountType: 2,
        needDiscountID: true,
        isFilter: false
      },
      {
        xname: "store",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        oneChart: "VueColumn",
        firstChart: "",
        secondChart: "",
        chartKey: "coupon_details_store_drawing",
        tableKey: "coupon_details_store_table_key",
        chartNum: "2",
        isTwo: false,
        tableTitle: "门店",
        TableconstantType: 8,
        ChartconstantType: 8,
        headerType: 2,
        parentID: -1,
        sortIndex: 1,
        chartSort: true,
        isFilter: false
      },
      {
        xname: "projects",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        oneChart: "VueColumn",
        chartKey: "coupon_details_item_drawing",
        tableKey: "coupon_details_item_table_key",
        chartNum: "1",
        isTwo: false,
        tableTitle: "使用项目",
        TableconstantType: 12,
        ChartconstantType: 12,
        headerType: 1,
        parentID: -1,
        sortIndex: 1,
        chartSort: true,
        isFilter: true
      },
      {
        xname: "card",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        oneChart: "VueColumn",
        chartKey: "coupon_details_open_card_drawing",
        tableKey: "coupon_details_open_card_table_key",
        constantKey: "coupon_details_open_card_dimension",
        chartNum: "1",
        isTwo: false,
        tableTitle: "储值金额",
        TableconstantType: 2,
        ChartconstantType: 2,
        headerType: 1,
        parentID: -1,
        sortIndex: 1,
        chartSort: false,
        isFilter: false
      },
      {
        xname: "channel",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "OneTable",
        oneChart: "VueColumn",
        chartKey: "coupon_details_cust_source_drawing",
        tableKey: "coupon_details_cust_source_table_key",
        constantKey: "coupon_details_new_cust_source_dimension",
        chartNum: "2",
        isTwo: false,
        tableTitle: "来源渠道",
        TableconstantType: 2,
        ChartconstantType: 2,
        headerType: 1,
        parentID: -1,
        sortIndex: 1,
        chartSort: true,
        isFilter: false
      }
    ]
  },
  // 漏斗转化
  {
    name: "coupons_change",
    value: [
      {
        name: "coupons_change",
        xname: "cycle",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "noDimensionTable",
        compareTable: "",
        oneChart: "Funnel",
        chartKey: "coupon_funnel_transfer_secondary_funnel_drawing",
        tableKey: "coupon_funnel_transfer_secondary_table_key",
        constantKey: "coupon_secondary_transfer_funnel_dimension",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: false,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        // tableTitle: "门店",
        headerType: 1,
        parentID: -1,
        // TableconstantType: 8,
        ChartconstantType: 2,
        dateFormat: 1,
        isIndex: true,
        ascending: 0,
        sortIndex: 1,
        identityType: 3,
        discountType: 2,
        needDiscountID: true
      },
      {
        xname: "lasttime",
        chartKey: "coupon_funnel_transfer_store_value_funnel_drawing",
        tableKey: "coupon_funnel_transfer_store_value_table_key",
        constantKey: "coupon_open_card_transfer_funnel_dimension"
      }
    ]
  },
  // 留存分析
  {
    name: "coupons_save",
    value: [
      {
        name: "coupons_save",
        xname: "customer",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "RetainTable",
        oneChart: "",
        chartKey: "retained_analysis_cust_coupon",
        tableKey: "retained_analysis_cust_coupon",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "",
        tableTitle: "日期",
        isDay: false,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: false,
        isTableKey: true,
        constantKey: "ladder_diagram_dimension",
        isIndex: true,
        chartTitle: "使用人数",
        identityType: 3,
        discountType: 2,
        needDiscountID: true
      },
      {
        xname: "expense",
        chartKey: "retained_analysis_cust_consume_coupon",
        tableKey: "retained_analysis_cust_consume_coupon",
        chartTitle: "活动使用人数"
      }
    ]
  },
  // 积分概况
  // {
  //   name: "integral_index",
  //   value: [
  //     {
  //       name: "integral_index",
  //       selectChart: "",
  //       selectTable: "SelectDrop",
  //       normalTable: "ColorTable",
  //       oneChart: "",
  //       chartKey: "",
  //       tableTitle: "积分商品名称",
  //       tableKey: "point_exchange_general_table_key",
  //       tableAddress: "bottom",
  //       tableNum: "4",
  //       isTwo: false,
  //       isDay: false,
  //       isTime: false,
  //       isChart: false,
  //       isTable: true,
  //       headerType: 4,
  //       parentID: -1,
  //       TableconstantType: 13,
  //       dateFormat: 1,
  //       chartZoom: false,
  //       isTableKey: true,
  //       isIndex: true,
  //       identityType: 2,
  //       sortIndex: 2,
  //       focus: 2
  //     }
  //   ]
  // },
  // 积分趋势
    {
        name: 'integral_target_trend',
        value: [
            {
                name: 'integral_target_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'point_trend_V2',
                tableKey: 'point_trend_V2_table_key',
                tableTitle: '日期',
                chartAddress: '',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
  // 积分分析
  // {
  //   name: "integral_analysis",
  //   value: [
  //     {
  //       name: "integral_analysis",
  //       xname: "analysis",
  //       selectChart: "SelectIndex",
  //       selectTable: "SelectDrop",
  //       normalTable: "OneTable",
  //       compareTable: "OneLevel",
  //       oneChart: "VueColumn",
  //       firstChart: "",
  //       secondChart: "",
  //       compareChart: "",
  //       chartKey: "point_get_distribution_of_point_get_distribution_chart_key",
  //       tableKey: "point_get_distribution_of_point_get_distribution_table_key",
  //       constantKey: "point_source_type",
  //       chartAddress: "center",
  //       tableAddress: "bottom",
  //       tableTitle: "有效积分",
  //       tableNum: "6",
  //       chartNum: "1",
  //       isTwo: false,
  //       isDay: false,
  //       isTime: false,
  //       isChart: true,
  //       isTable: true,
  //       chartZoom: true,
  //       isTableKey: true,
  //       headerType: 1,
  //       parentID: -1,
  //       TableconstantType: 2,
  //       ChartconstantType: 2,
  //       dateFormat: 1,
  //       isIndex: true,
  //       sortIndex: 1,
  //       identityType: 2
  //     }
  //   ]
  // },
  // 兑换商品分析
  // {
  //   name: "integral_goods",
  //   value: [
  //     {
  //       name: "integral_goods",
  //       xname: "analysis",
  //       selectChart: "SelectIndex",
  //       selectTable: "SelectDrop",
  //       normalTable: "OneTable",
  //       compareTable: "OneLevel",
  //       oneChart: "VueColumn",
  //       tableTitle: "兑换商品",
  //       chartAddress: "center",
  //       tableAddress: "bottom",
  //       tableNum: "6",
  //       chartNum: "1",
  //       isTwo: false,
  //       isDay: false,
  //       isTime: false,
  //       isChart: true,
  //       isTable: true,
  //       chartZoom: true,
  //       isTableKey: true,
  //       chartKey: "exchange_distribution_drawing",
  //       tableKey: "exchange_distribution_table_key",
  //       headerType: 1,
  //       parentID: -1,
  //       TableconstantType: 13,
  //       ChartconstantType: 13,
  //       isIndex: true,
  //       ascending: 0,
  //       identityType: 2,
  //       sortIndex: 1,
  //       chartSort: true
  //     }
  //   ]
  // }
  // 会员等级趋势
  {
    name: 'member_level_trend',
    value: [
      {
        name: 'member_level_trend',
        selectChart: 'SelectChart',
        selectTable: 'SelectClass',
        normalTable: 'DateTable',
        compareTable: 'ContrantTable',
        oneChart: 'VueHighchart',
        chartKey: 'target_member_indicator_trend',
        tableKey: 'target_member_indicator_trend_table',
        tableTitle: '日期',
        chartAddress: '',
        tableAddress: 'bottom',
        chartNum: '2',
        tableNum: '6',
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1, // 会员等级趋势 图graph的参数
        constantKey: '',
        parentID: 0,
        type: 0,
        dateFormat: 1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        sortIndex: 1,
        byWhichWay: "byMonth",
      },
    ],
  },
  // 会员等级增长
  {
    name: 'member_level_growth',
    value: [
        {
            name: 'member_level_growth',
            xname: 'RatioOne',
            selectChart: 'SelectChart',
            selectTable: 'SelectClass',
            normalTable: 'ContrantTable',
            oneChart: 'VueColumn',
            chartKey: 'member_level_ring_growth_trend',
            tableKey: 'member_level_ring_growth_table',
            chartAddress: 'center',
            tableAddress: 'bottom',
            tableTitle: '日期',
            chartNum: '1',
            tableNum: '6',
            isTwo: false,
            isDay: false,
            isTime: false,
            isChart: true,
            isTable: true,
            headerType: 2,
            constantKey: '',
            parentID: 0,
            TableconstantType: 3,
            ChartconstantType: 3,
            IndexCompareType: 0,
            dateFormat: 2,
            chartZoom: true,
            isTableKey: true,
            isIndex: true,
            sortIndex: 1,
            byWhichWay: "byMonth",
            type: 2,
        },
        {
          xname: "RatioTwo",
          chartKey: 'member_level_ring_growth_trend',
          tableKey: 'member_level_year_growth_table',
          type: 1,
        }
    ],
  },
];
export { marketHeader, marketContent };
